/**
 * Profiles Controller
 */
waApp.controllers.Profiles = {
	languageSetup: function() {
		let primaryLanguage = null;
		let languageConstraint = $("#language-constraint").html();

		// Simple solution to the case when an user has unlimited languages
		if (languageConstraint === -1) {
			languageConstraint = 9999;
		}

		// Remove one language because on main language after check unlimited languages constraints
		languageConstraint = languageConstraint - 1;

		// If only 1 language is allowed user can set only main language and no additional languages
		if (languageConstraint === 0) {
			$("#languages").attr("disabled", "disabled");
		}

		// Todo: Is this thing used anymore? Remove?
		$("select #language").select2();
		$("select #language").change(function(e) {
			e.preventDefault();
			primaryLanguage = $(this).val();
			if (primaryLanguage === undefined || primaryLanguage.length === 0 || primaryLanguage === "") {
				$(".additional-languages").hide();
			} else {
				$(".additional-languages").show();
			}
			$("#languages option[value=\"" + primaryLanguage + "\"]").remove();
		});
		$("select #language").trigger("change");

		$("#languages").select2({
			tags: true,
			maximumSelectionLength: languageConstraint,
			ajax: {
				url: "/languages/index.json",
				cache: false,
				data: function(params) {
					return params;
				},
				dataType: "json",
				processResults: function(data, params) {
					let languageId = $("#language").val();
					let languageIds = $("#languages").val();

					let results = [];

					for (let property in data.languages) {
						if (property === languageId) {
							continue;
						}

						if (languageIds !== null) {
							let matched = false;
							for (let i = 0; i < languageIds.length; i++) {
								if (languageIds[i] == property) {
									matched = true;
									break;
								}
							}
							if (matched) {
								continue;
							}
						}

						results.push({
							text: data.languages[property],
							id: property
						});
					}

					results.sort(function(a, b) {
						let aName = a.text.toLowerCase();
						let bName = b.text.toLowerCase();
						return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
					});

					return { results: results };
				}
			}
		}).trigger("change");
	},
	view: function() {
		$.each($(".employee-card"), function(index, object) {
			let employeeId = "#" + $(object).attr("id");
			let employeeCard = $(employeeId);

			employeeCard.on("click", ".employee-show-bio, .employee-img", function(event) {
				event.preventDefault();
				employeeCard.find(".employee-bio").show();
			});

			employeeCard.on("click", ".employee-bio-close", function(event) {
				event.preventDefault();
				employeeCard.find(".employee-bio").hide();
			});
		});

		$.each($(".more-or-less-link"), function() {
			const publicationDescription = $(this).parent().prev();
			if (publicationDescription.text().length > 650) {
				publicationDescription.addClass("description-truncate");
				$(this).css("display", "block");
			}
			$(this).click(function() {
				publicationDescription.toggleClass("description-truncate");
				publicationDescription.hasClass("description-truncate")
					? $(this).html("<i class=\"wa-arrow wa-arrow-medium\">&nbsp;</i>" + i18next.t("common.read_more"))
					: $(this).html("<i class=\"wa-arrow wa-arrow-top-right wa-arrow-medium\">&nbsp;</i>" + i18next.t("common.read_less"));
			});
		});
	},
	edit: function() {
		$(".employee-card").each(function() {
			$(this).hover(function() {
				$(this).next().css("display", "flex");
			});
		});
		$(".employee-edit-overlay").each(function() {
			$(this).mouseleave(function() {
				$(this).hide();
			});
		});

		$(".profile-project").each(function() {
			$(this).hover(function() {
				$(this).next().css("display", "flex");
			});
		});
		$(".profile-project-overlay").each(function() {
			$(this).mouseleave(function() {
				$(this).hide();
			});
		});

		$.each($(".more-or-less-link"), function() {
			$(this).parent().prev().addClass("description-truncate");
		});
	},

	basicInformation: function() {
		waUtils.inputLanguageToggle();

		$("#profile-photo-list").sortable({
			handle: ".move",
			start: function(event, ui) {
				ui.item.startPosition = ui.item.index();
			},
			update: function(event, ui) {
				$.ajax({
					headers: {
						Accept: "application/json"
					},
					url: "/" + waApp.getLanguage() + "/files/update-position/ProfileImage",
					type: "POST",
					dataType: "json",
					data: {
						id: ui.item.data("image-id"),
						position: ui.item.index() + 1
					},
					success: function(data, textStatus, jqXHR) {
						console.log(data);
					}
				});
			}
		});

		$("#profile-specializations-ids").select2({
			tags: true
		});
	}
};
